import Bacon from 'baconjs';

export default function (dispatcher) {
    const {stream} = dispatcher;
    const urlStream = stream('URL').map('.query.list');

    const selected = Bacon.update(
        undefined,
        [urlStream],
        (unused, newValue) => newValue,
        [stream('LIST-UPDATE')],
        (unused, newValue) => newValue,
        [stream('FILTERS-REMOVE-ALL')],
        () => undefined
    );

    return Bacon.combineTemplate({
        selected,
    });
}
